import Vue from 'vue'
import VueTour from 'vue-tour'

// eslint-disable-next-line no-undef
require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)
